module.exports = __webpack_public_path__ + "static/media/Monde_Cocktail_BG1.9f906567.jpg";